export type VoteBarItem = {
    id: number;
    count: number;
    code: string;
};

type Props<T extends VoteBarItem> = {
    items: T[];
    colors: Record<string, string>;
    getLabel: (item: T) => string;
    formatPercent: (value: number) => string;
    onSegmentClick?: (item: T) => void;
};

function VoteBar<T extends VoteBarItem>({ items, colors, getLabel, formatPercent, onSegmentClick }: Props<T>) {
    const total = items.reduce((sum, item) => sum + item.count, 0);
    if (total === 0) return null;

    const segments = items
        .filter((item) => item.count > 0)
        .map((item) => ({
            item,
            percent: (item.count / total) * 100,
            color: colors[item.code],
            label: getLabel(item)
        }));

    return (
        <div className='votebar-block'>
            <div className='votebar'>
                {segments.map((segment) => (
                    <span
                        key={segment.item.code}
                        style={{ width: `${segment.percent}%`, backgroundColor: segment.color, cursor: onSegmentClick ? 'pointer' : undefined }}
                        onClick={onSegmentClick ? () => onSegmentClick(segment.item) : undefined}
                    />
                ))}
            </div>
            <div className='votebar-legend'>
                {segments.map((segment) => (
                    <span
                        key={segment.item.code}
                        style={{ cursor: onSegmentClick ? 'pointer' : undefined }}
                        onClick={onSegmentClick ? () => onSegmentClick(segment.item) : undefined}
                    >
                        <i style={{ backgroundColor: segment.color }} />
                        {segment.label} {formatPercent(segment.percent)}
                    </span>
                ))}
            </div>
        </div>
    );
}

export default VoteBar;
